import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Graph } from './api-interfaces/graphDashboard.interface';
import { KpisDashboardIncadea } from './api-interfaces/api-interface-incadea-dashboard';
import { MyCalendaryIncadea } from './api-interfaces/api-interface-incadea-Mycalendary';
import { dashboardFilters } from './api-interfaces/dashboardFilters.interface';
import { HelperService } from '../helperService';

@Injectable({
  providedIn: 'root'
})
export class DashboardIncadeaService {
  ApiURL: string = '';
  constructor(private http: HttpClient,public helperService: HelperService) {
    this.ApiURL = environment.CustomdashboardUrl + 'IncadeaDashboard/';
  }

  public getIBKPIs(roleId:number, countryId:number, initialDate:string,finalDate:string,specificId?:string){   
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };         
    return this.http.get<KpisDashboardIncadea[]>(`${this.ApiURL}KPIs/${roleId}/${countryId}/${initialDate}/${finalDate}`+(specificId ? `/${specificId}` : ''),requestOptions)
 }

 public getIBMyCalendary(roleId:number, countryId:number, secondId?:number){     
  const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
  const requestOptions = {
      headers: headers,
    };       
  return this.http.get<any>(`${this.ApiURL}MyCalendary/${roleId}/${countryId}`+(secondId ? `/${secondId}` : ''),requestOptions)
}

public getIBFilters(roleId:number, countryId:number, companyId?:string){
  const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
  const requestOptions = {
      headers: headers,
    };
  return this.http.get<dashboardFilters>(`${this.ApiURL}GetDashboardFilters/${roleId}/${countryId}`+(companyId ? `/${companyId}` : ''),requestOptions)
}

 public getIBGraph(
  roleId:number,
  countryId:number,
  initialDate:string,
  finalDate:string,
  firstId:string,
  secondId:number,
  thirdId:string,
  timeId:number,
  specificId?:number){
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return this.http.get<Graph[]>(`${this.ApiURL}GraphIncadea/${roleId}/${countryId}/${initialDate}/${finalDate}/${firstId}/${secondId}/${thirdId}/${timeId}/${specificId}`,requestOptions)
  }

}